/** Original illustrative drawing; it has no relationship to a saved board. */
export function LandingPlan({
  trace = false,
  opacity = 0.65,
  viewBox = "0 0 420 480",
}: {
  trace?: boolean;
  opacity?: number;
  /** A window onto the same drawing coordinates, for cropped stills. */
  viewBox?: string;
}) {
  return (
    <svg className="study-plan" viewBox={viewBox} aria-hidden="true">
      <g fill="none" stroke="#a9aaa1" strokeWidth="0.65">
        <path d="M54 28H367M55 21V36M365 21V36M29 51V403M22 52H37M22 399H37M55 422H367M55 415V429M365 415V429" />
        <path d="m51 32 8-8m302 8 8-8m-344 33 8-8m-8 354 8-8m18 31 8-8m302 8 8-8" />
      </g>
      <path
        d="M55 52H365V400H55Z"
        fill="#faf9f5"
        stroke="#3d413b"
        strokeWidth="5"
      />
      <path d="M222 56H361V210H222Z" fill="#edf0e7" />
      <g stroke="#d4d8c9" strokeWidth="0.65">
        {[78, 103, 128, 153, 178, 203].map((y) => (
          <path key={y} d={`M225 ${y}H362`} />
        ))}
        {[242, 267, 292, 317, 342].map((x) => (
          <path key={x} d={`M${x} 55V209`} />
        ))}
      </g>
      <g fill="none" stroke="#454a42" strokeWidth="4">
        <path
          d={`M221 53V119M221 163V211H${trace ? 230 : 252}M${trace ? 326 : 305} 211H365M55 169H110M153 169H221M55 281H196M247 281H365`}
        />
      </g>
      <g fill="none" stroke="#a3a797" strokeWidth="0.85">
        <path d="M221 119H177A44 44 0 0 0 221 163M110 169V126A43 43 0 0 1 153 169M196 281V332A51 51 0 0 0 247 281" />
      </g>
      <g fill="#f9f8f3" stroke="#696f62" strokeWidth="0.8">
        <path d="M51 195H59V252H51ZM51 310H59V365H51ZM268 396H342V404H268ZM92 48H162V56H92ZM361 270H369V345H361Z" />
        <path d="M219 170H224V197H219Z" />
        {!trace && <path d="M258 208H299V214H258Z" />}
      </g>
      <g fill="none" stroke="#8f9687" strokeWidth="0.9">
        <path d="M73 67H201V148H184V84H73ZM122 67V84M163 67V84" />
        <rect x="82" y="70" width="23" height="10" />
        <circle cx="192" cy="108" r="4" />
        <circle cx="192" cy="123" r="4" />
        <rect x="91" y="119" width="64" height="20" />
        <path d="M104 140V151H116V140M132 140V151H144V140" />
        <rect x="103" y="206" width="67" height="36" />
        <path d="M110 200V194H127V200M144 200V194H161V200M110 248V254H127V248M144 248V254H161V248M97 215H89V233H97M176 215H184V233H176" />
        <rect x="77" y="305" width="92" height="36" />
        <path d="M82 305V335H164V305M109 305V335M138 305V335" />
        <rect x="94" y="354" width="62" height="22" />
        <path d="M185 350h28v30h-28ZM189 354h20v22h-20Z" />
        <path d="M293 310H344V370H293ZM293 327H344M297 314H315V324H297ZM322 314H340V324H322Z" />
        <rect x="263" y="309" width="18" height="18" />
        <rect x="263" y="351" width="18" height="18" />
      </g>
      <g
        stroke="#8e9c7d"
        strokeWidth="0.7"
        fill="none"
        transform="translate(293 125)"
      >
        {[0, 30, 60, 90, 120, 150].map((angle) => (
          <ellipse key={angle} rx="17" ry="35" transform={`rotate(${angle})`} />
        ))}
        <circle r="25" />
        <circle r="12" />
        <path d="M-29 0H29M0-29V29M-19-19L19 19M-19 19L19-19" />
      </g>
      <g
        fill="#68705f"
        fontSize="7.5"
        fontFamily="monospace"
        textAnchor="middle"
        letterSpacing="0.8"
      >
        <text x="136" y="102">
          KITCHEN
        </text>
        <text x="139" y="267">
          DINING
        </text>
        <text x="135" y="391">
          LIVING
        </text>
        <text x="298" y="188">
          COURTYARD
        </text>
        <text x="316" y="391">
          BEDROOM
        </text>
      </g>
      {trace && (
        <g opacity={opacity}>
          <path
            d="M206 193H330V232H206Z"
            fill="#ec7c4530"
            stroke="#c64e2b"
            strokeWidth="1"
            strokeDasharray="5 3"
          />
          <path
            d="M230 208H326M230 215H326M249 208V215M301 208V215"
            fill="none"
            stroke="#cf552f"
            strokeWidth="1.5"
          />
          <path
            d="M254 244Q282 265 316 244m-9 1 9-1-2 9"
            stroke="#cf552f"
            strokeWidth="1.5"
            fill="none"
          />
          <text
            x="253"
            y="279"
            fill="#b84121"
            fontSize="8.5"
            fontFamily="monospace"
          >
            A WIDER OPENING
          </text>
        </g>
      )}
      <g fill="none" stroke="#6d7568" strokeWidth="0.85">
        <path d="M363 454V436m-4 7 4-7 4 7M61 452H135M61 448V456M98 448V456M135 448V456" />
      </g>
      <g fill="#828879" fontSize="6.5" fontFamily="monospace">
        <text x="58" y="441">
          CONCEPT / NOT TO SCALE
        </text>
        <text x="360" y="432">
          N
        </text>
      </g>
    </svg>
  );
}

/** Fade a complete revised drawing over the original in the same coordinates. */
export function LandingTrace({ opacity }: { opacity: number }) {
  return (
    <div className="study-plan-comparison">
      <LandingPlan />
      <div className="study-plan-overlay" style={{ opacity }}>
        <LandingPlan trace opacity={1} />
      </div>
    </div>
  );
}
